 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		21: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		21: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"44ddd90d0e3eb3e19e07c741c1f57f4ed664d108","2":"e8af10bfb339d6526e89f8024a40c872b53bf659","3":"f272b16ee2a0d1c485649d8b9b5deddaf0df39f5","4":"0cad2729e33162aa1adea508276f603dda33da6f","5":"58a371f8d83cb305c02c09b9b7b3405887cd7691","6":"99fd69c94f5cdf7349016a615dfe0e526fcbd86f","7":"9d0dc136a0b7b625e562ccf46d6dd1b9a70579eb","8":"framework","9":"16badffece84c8c12669188d3597933920910d8a","10":"2ceafe490b39a809437266f51cd485286469b108","11":"82a3727c792390d65b112af4a9c4211d97d09478","12":"d984edba7e410c9fccf864996292c8a19fe82279","13":"fb7d5399","15":"0a8c9bce28bfd1c1e833f00bf8e08a537def04c2","16":"6763fea0","17":"695b7dcbd3d57ae7893edb15dc27c662c703298a","18":"91f615fd248cae8684442580222ae5de889ae8e3","19":"ad861c97453a6af95e0d2ef426b052715b85fbca","20":"cb1608f2","24":"component---src-pages-404-js","25":"component---src-pages-about-us-js","26":"component---src-pages-apidoc-js","27":"component---src-pages-blog-js","28":"component---src-pages-blogv-2-js","29":"component---src-pages-blogv-3-js","30":"component---src-pages-contact-us-js","31":"component---src-pages-credit-scoring-api-js","32":"component---src-pages-en-js","33":"component---src-pages-ezloan-js","34":"component---src-pages-index-js","35":"component---src-pages-pfm-js","36":"component---src-pages-recommendation-api-js","37":"component---src-pages-test-js","38":"component---src-pages-transaction-categorization-api-js","39":"component---src-pages-txn-data-gui-js","40":"component---src-templates-blog-post-js","41":"ea88be26"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"6d2431792936e6f76ede","2":"1f40cb31b6d585cab6ff","3":"5791ee4386fcb10b4685","4":"b7bbd379826107744e3a","5":"ea6f18bfd008d5202c2a","6":"ce365d9f9207c9270ec7","7":"a9f7bc57495d5aebef33","8":"045bf563c91b5d932539","9":"c5ef7def8677957db354","10":"03139e68261112b1839d","11":"04ca78a3fba07a6a9744","12":"529d51d7cf8983835dfa","13":"4c4814799d4b17aa2281","14":"062a54b2cf7547045c4d","15":"6679e3b304a704eb6613","16":"55ad00ee53633fa75e0b","17":"6dcbc0133bf22d66e904","18":"28d29f4e4c445c264102","19":"0c79e98a12d02a0e4cba","20":"ea7f984133f94a1942e1","24":"a072d4e5af9faeda7589","25":"94ef0533ec082663fa7c","26":"26fa935bb6f90673d74b","27":"1558c165c7937a71a4da","28":"b1b3980d237b95687727","29":"a51befc9226bcd63bb9f","30":"492f69f3b1aff62192d7","31":"024a2a445aa2f94f388e","32":"91a651e682faeaf693f7","33":"9462085550e3221881e0","34":"17f0e74fb3166e679337","35":"aaa2b0da4ec89d1178c2","36":"b68ece13026161a7f673","37":"551437cbf5c6eea99756","38":"540418feb7a09b60f07f","39":"a78dd35c7555d8dd5140","40":"9c5986dcd2aefd01acf6","41":"1effe242fa5e332abf26"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"44ddd90d0e3eb3e19e07c741c1f57f4ed664d108","2":"e8af10bfb339d6526e89f8024a40c872b53bf659","3":"f272b16ee2a0d1c485649d8b9b5deddaf0df39f5","4":"0cad2729e33162aa1adea508276f603dda33da6f","5":"58a371f8d83cb305c02c09b9b7b3405887cd7691","6":"99fd69c94f5cdf7349016a615dfe0e526fcbd86f","7":"9d0dc136a0b7b625e562ccf46d6dd1b9a70579eb","8":"framework","9":"16badffece84c8c12669188d3597933920910d8a","10":"2ceafe490b39a809437266f51cd485286469b108","11":"82a3727c792390d65b112af4a9c4211d97d09478","12":"d984edba7e410c9fccf864996292c8a19fe82279","13":"fb7d5399","15":"0a8c9bce28bfd1c1e833f00bf8e08a537def04c2","16":"6763fea0","17":"695b7dcbd3d57ae7893edb15dc27c662c703298a","18":"91f615fd248cae8684442580222ae5de889ae8e3","19":"ad861c97453a6af95e0d2ef426b052715b85fbca","20":"cb1608f2","24":"component---src-pages-404-js","25":"component---src-pages-about-us-js","26":"component---src-pages-apidoc-js","27":"component---src-pages-blog-js","28":"component---src-pages-blogv-2-js","29":"component---src-pages-blogv-3-js","30":"component---src-pages-contact-us-js","31":"component---src-pages-credit-scoring-api-js","32":"component---src-pages-en-js","33":"component---src-pages-ezloan-js","34":"component---src-pages-index-js","35":"component---src-pages-pfm-js","36":"component---src-pages-recommendation-api-js","37":"component---src-pages-test-js","38":"component---src-pages-transaction-categorization-api-js","39":"component---src-pages-txn-data-gui-js","40":"component---src-templates-blog-post-js","41":"ea88be26"}[chunkId]||chunkId) + "." + {"0":"45d81f69b1cfbcaf1e1d","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
